
export default {
  name: 'ThreeStep',
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    loggedIn() {
      return this.$store.state.loginStatus.loggedIn == 1
    },
  },
}
